import React, { useEffect, useState, useContext } from 'react';
import * as language from '../constants/languages';
import DrawerIcon from '../assets/svg/header/drawericon.svg';
import WhatsApp from '../assets/svg/header/whatsapp.svg';
import ShoppingCart from '../assets/svg/shopping_cart.svg';
import CompanyLogo from '../assets/header_logo.png';
import Badge from '@mui/material/Badge';
import { getSupportData } from '../services/services';
import '../styles/HeaderMain.css'
import { AuthContext } from '../pages/RootPage';
import { isMobile } from 'react-device-detect';
import RightArrow from '../assets/svg/right.svg'
import { useNavigate } from 'react-router-dom';

export default function HeaderMain() {
    const navigate = useNavigate()
    const [whatsAppNo, setwhatsAppNo] = useState('')
    const [supportNumber, setsupportNumber] = useState('')
    const [badgeCount, setbadgeCount] = useState(0)
    const [logo, setlogo] = useState(CompanyLogo)
    const { toggleDrawer } = useContext(AuthContext);

    useEffect(() => {
        getCompanyInfo();
        getSupportInfoData();
        getCartCount();
        window.addEventListener('productQtyChange', getCartCount);
        return () => {
            window.removeEventListener('productQtyChange', getCartCount);
            localStorage.removeItem('cateFilter');
            localStorage.removeItem('brandFilter');
            localStorage.removeItem('ratingFilter');
        }
    }, [])

    const getCartCount = () => {
        const cart = localStorage.getItem('cartItems');
        if (!cart) {
            setbadgeCount(0);
        } else {
            const cartItems = JSON.parse(cart);
            setbadgeCount(cartItems?.customerCartItems?.length || 0);
        }
    };

    //get store name and logo
    async function getCompanyInfo() {
        const value = localStorage.getItem('companyInfo')
        if (value) {
            let companyInfo = JSON.parse(value);
            const Logo = (companyInfo.logo && companyInfo.logo !== "") ? companyInfo.logo : CompanyLogo;
            setlogo(Logo);
            setwhatsAppNo(companyInfo.whatsAppNo || "")
        }
    }

    async function getSupportInfoData() {
        await getSupportData(language.companyidValue).then((supportData) => {
            if (supportData.status === 'success') {
                setsupportNumber(supportData.data.contactNos)
            }
        })
    }
    async function callNow() {
        window.open(`tel:${supportNumber}`)
    }

    async function openWhatsapp() {
        if (isMobile) {
            window.open('whatsapp://send?phone=' + whatsAppNo)
        }
        else {
            window.open(`https://web.whatsapp.com/send?phone=${whatsAppNo}`)
        }
    }

    return (
        <div className='containerHeaderMain'>
            <div className='header-mobile-bar' style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between', paddingInline: '12px' }}>
                <div className='drawer-icon' style={{ margin: 0, cursor: 'pointer' }}>
                    <img src={DrawerIcon} style={{ width: 20, height: 20 }} onClick={() => toggleDrawer()} alt="Menu" />
                </div>

                <div
                    style={{
                        display: "flex",
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingInline: "8px",
                    }}
                    onClick={() => navigate("/")}
                >
                    <img src={logo || CompanyLogo} height="auto" width={140} alt="Store Logo" style={{ cursor: "pointer", maxWidth: "100%", maxHeight: "38px", objectFit: "contain" }} />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div
                        style={{ cursor: "pointer", padding: "4px 6px", display: "flex", alignItems: "center" }}
                        onClick={() => navigate("/Cart")}
                        title="Cart"
                    >
                        <Badge badgeContent={badgeCount} color="warning">
                            <img src={ShoppingCart} style={{ width: 24, height: 24 }} alt="Cart" />
                        </Badge>
                    </div>
                    {whatsAppNo ? (
                        <div className='whatsapp-header' onClick={() => openWhatsapp()} style={{ cursor: 'pointer' }}>
                            <img src={WhatsApp} style={{ width: 34, height: 34 }} alt="WhatsApp" />
                        </div>
                    ) : null}
                    <div className="CallNowCommon" style={{ visibility: supportNumber ? 'visible' : "hidden", cursor: 'pointer' }} onClick={() => callNow()}>
                        <p style={{ margin: 0, color: "#fff", fontSize: '12px' }}>Call Now</p>
                    </div>
                </div>
            </div>

            <div className='routeWrapper' style={{ marginTop: '4px', paddingInline: '15px' }}>
                <p className='route-names' onClick={() => navigate('/')}>Home</p>
                <img src={RightArrow} alt=">" />
                <p style={{ fontFamily: 'Poppins-Regular', fontSize: '14px', flexWrap: 'nowrap', margin: 0 }} onClick={() => navigate('/Categories')}>Categories</p>
            </div>
        </div>
    );
}